import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  useMediaQuery,
} from "@material-ui/core";
import { FileDropInput } from "./FileDropInput";
import { Autocomplete, Alert } from "@material-ui/lab";
import { Formik } from "formik";

import { SCHOOL_URL } from "../crud/helpers/routes";
import { getMultipartParams, handleResponse } from "../crud/helpers/validate";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: ({ isDesktop }) => (!isDesktop ? "70%" : "50%"),
    [theme.breakpoints.up("sm")]: {
      width: "40%",
    },
    maxWidth: 500,
  },
  progress: {
    marginLeft: 10,
  },
}));

export const BulkModal = ({
  showSelectTeam = false,
  urlDownloadTemplate,
  onDownloadTemplate,
  errorsBulk,
  open,
  setOpen,
  bulk,
  setBulk,
  school,
  loading,
  steps,
  setSteps,
  onFinish,
  setLoading,
  validateBulk,
  bulkRequest = () => {},
}) => {
  const [teams, setTeams] = useState([]);

  const isDesktop = useMediaQuery("(min-width: 600px)");
  const classes = useStyles({ isDesktop });
  const getTeams = (setterFunction, slug) => {
    return fetch(
      `${SCHOOL_URL}/${slug}/teams?per_page=100`,
      getMultipartParams("GET")
    )
      .then((res) => handleResponse(res))
      .then((json) => setterFunction(json.items))
      .catch((e) => {
        console.error(e);
        return e;
      });
  };

  useEffect(() => {
    setBulk(null);
    setSteps(1);
    if (school && school !== null && school.slug && school.slug !== null)
      getTeams(setTeams, school.slug);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [school]);

  return (
    <Dialog
      PaperProps={{
        className: classes.paper,
      }}
      open={open}
      id="bulk_dialog"
      onClose={() => setOpen(false)}
    >
      <Formik
        id="fileuoload"
        initialValues={{
          team_id: null,
        }}
        validate={() => ({})}
        onSubmit={(values, { setSubmitting }) => {
          setLoading(true);
          setOpen(false);
          bulkRequest(values);
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <>
            <DialogTitle className="pb-1">Upload CSV File</DialogTitle>
            <DialogContent className="py-0">
              <div className="mb-4 d-flex flex-column">
                {onDownloadTemplate ? (
                  // Generated client-side (no hosting dependency) — used
                  // by flows whose template is built from code so it
                  // always matches what the importer expects.
                  <button
                    type="button"
                    onClick={onDownloadTemplate}
                    className="mb-5"
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "#2196f3",
                      cursor: "pointer",
                      textAlign: "left",
                      font: "inherit",
                    }}
                  >
                    Download CSV Template{" "}
                    <span className="material-icons" style={{ verticalAlign: "middle" }}>
                      cloud_download
                    </span>
                  </button>
                ) : (
                  <a
                    href={urlDownloadTemplate}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mb-5"
                  >
                    Download CSV Template{" "}
                    <span className="material-icons">cloud_download</span>
                  </a>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span style={{ fontWeight: "1000" }}>Note</span>
                  <span style={{ color: "#6B6B6B" }}>
                    <strong>Important:</strong> Ensure the order of the columns
                    in the template is <strong>not</strong> altered.{" "}
                    <strong>
                      If you are uploading your own csv the order is first name,
                      last name, email and phone number.
                    </strong>
                  </span>
                </div>
              </div>
              <br />
              {showSelectTeam && (
                <Autocomplete
                  selectedAutocompleteValues={values.team_id}
                  id="bulk_team_id"
                  className="mb-5"
                  options={teams}
                  defaultValue={[]}
                  setBulk
                  getOptionLabel={(option) =>
                    (option && typeof option === "object" && option.name) || ""
                  }
                  onChange={(event, val) => {
                    const teamId = val?.id;
                    setFieldValue("team_id", teamId);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder="Teams (optional)"
                    />
                  )}
                />
              )}
              <FileDropInput
                setterFunction={setBulk}
                value={bulk}
                type=".csv"
                message="Add CSV file"
              />
            </DialogContent>
            <DialogActions>
              <Button
                id="cancel_bulk_btn_dialog"
                type="reset"
                onClick={() => setOpen(false)}
                color="secondary"
              >
                Cancel
              </Button>

              <button
                type="submit"
                id="submit_validate_bulk_btn_dialog"
                disabled={!bulk || !school?.slug}
                onClick={validateBulk}
                className="btn btn-primary btn-elevate kt-login__btn-primary d-flex ml-3"
              >
                Validate File
              </button>
            </DialogActions>

            {steps >= 2 && (
              <Alert severity="info">
                We are validating your CSV File{" "}
                {loading && steps === 2 && (
                  <CircularProgress
                    color="inherit"
                    size={18}
                    className={classes.progress}
                  />
                )}
              </Alert>
            )}
            <br />
            {steps === 2.1 && (
              <Alert severity="error">
                Error. file could not be uploaded to s3, please click validate
                file again
              </Alert>
            )}

            {steps === 2.2 && (
              <Alert severity="error">
                <ul>
                  {errorsBulk.map((error) => (
                    <li style={{ listStyleType: "disc" }}>{error}</li>
                  ))}
                  <li> please validate file again</li>
                </ul>
              </Alert>
            )}

            {steps >= 3 && (
              <>
                <Alert severity="success">
                  File validated. Press submit to finish
                </Alert>
                <DialogActions>
                  <button
                    type="submit"
                    id="submit_bulk_btn_dialog"
                    onClick={showSelectTeam ? handleSubmit : bulkRequest}
                    className="btn btn-primary btn-elevate kt-login__btn-primary d-flex ml-3"
                  >
                    Submit
                  </button>
                </DialogActions>
              </>
            )}

            <br />
          </>
        )}
      </Formik>
    </Dialog>
  );
};

BulkModal.propTypes = {
  // Toggles the team-picker inside the modal. Off by default —
  // only the few bulk flows that scope by team turn it on.
  showSelectTeam: PropTypes.bool,
  // URL to the example CSV / XLSX template the user can download.
  // Ignored when onDownloadTemplate is provided.
  urlDownloadTemplate: PropTypes.string,
  // Optional client-side template generator. When provided, the
  // "Download CSV Template" link builds and downloads the file in the
  // browser instead of linking to a hosted URL.
  onDownloadTemplate: PropTypes.func,
  // Validation errors surfaced from the parsed file rows.
  errorsBulk: PropTypes.array,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  // Parsed bulk payload — array of row objects or null before
  // anything's been picked.
  bulk: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  setBulk: PropTypes.func.isRequired,
  // Selected school — has at least { slug }. Used by the team
  // picker fetch.
  school: PropTypes.object,
  loading: PropTypes.bool,
  // Step-wizard state — shape depends on the caller (Polls /
  // Onboarding both use it differently).
  steps: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  setSteps: PropTypes.func,
  onFinish: PropTypes.func,
  setLoading: PropTypes.func,
  validateBulk: PropTypes.func,
  // Final upload call. Defaults to a no-op so a caller that
  // forgets to wire it doesn't crash the modal.
  bulkRequest: PropTypes.func,
};
